var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-5 d-flex justify-content-between",staticStyle:{"padding-top":"10vh"}},[_c('div',{staticClass:"col-12 col-xl-8 overflow-auto"},[_c('TreeChart',{attrs:{"json":_vm.treeData}})],1),_c('CustomizeTree')],1)}
var staticRenderFns = []

export { render, staticRenderFns }